import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import AdminTable from "../Administrator/Helpers/AdminTable";
import {
  deleteClientAbonement,
  frostClientAbonement,
  getAbonementsClient,
  cancelClientSubscription,
  postRestoreClientAbonementThunk
} from "src/store/Slices/ClientsSlice";
import { formateDate } from "src/components/helpers/formateDate";
import AddAbonement from "./Modals/AddAbonement";
import EditAbonement from "./Modals/EditAbonement";
import SureModal from "src/components/Modals/SureModal";
import { openNotification } from "src/components/helpers/notification";
import { Button, DatePicker, Space, Switch, Popover } from "antd";
import dayjs from "dayjs";
import AbonementShowFr from "./Modals/AbonementShowFr";

const { RangePicker } = DatePicker;
const ClientsAbonementsNew = ({
  clientInfo,
  title,
  page,
  pageSize,
  setPage,
  setPageSize,
  isActive,
  isDeleted,
  mnemo,
}) => {
  const dispatch = useDispatch();
  const items = [
    {
      key: "1",
      label: "Редактировать",
      onClick: () => {
        setIsOpenAddEditModal(true);
      },
      disabled: !mnemo?.children
        ?.find((el) => el.name === "Таблица абонементов")
        ?.children.find((ele) => ele.mnemo === "updateBtn"),
    },
    {
      key: "2",
      label: "Просмотр заморозок",
      onClick: () => {
        setIsOpenShowFrModal(true);
      },
      // disabled : (!mnemo?.children?.find(el => el.name === 'Таблица абонементов')?.children.find(ele => ele.mnemo === 'updateBtn'))
    },
    isDeleted && {
      key: "4",
      label: "Восстановить",
      onClick: () => {
        dispatch(postRestoreClientAbonementThunk({ userAbonementId: abonementInfo.id })).then((res) => {
          if (res.meta.requestStatus === 'fulfilled') {
            openNotification({
              type: "success",
              message: `Абонемент успешно восстановлен)`,
            });
            dispatch(getAbonementsClient({ clientId: clientInfo.id }));
          }
        });
      },
      disabled : !isDeleted
    },
    {
      key: "3",
      label: "Удалить",
      onClick: () => {
        setOpenDeliteAbonementModal(true);
      },
      disabled: !mnemo?.children
        ?.find((el) => el.name === "Таблица абонементов")
        ?.children.find((ele) => ele.mnemo === "deleteBtn"),
    },
  ];
  const [isOpenAddEditModal, setIsOpenAddEditModal] = useState(false);
  const [isOpenShowFrModal, setIsOpenShowFrModal] = useState(false);
  const [abonementInfo, setIsAbonementInfo] = useState();
  // const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  const [openDeliteAbonementModal, setOpenDeliteAbonementModal] =
    useState(false);
  const [date, setDate] = useState([dayjs()]);
  const [clicked, setClicked] = useState(false);
  const [cancelClicked, setCancelClicked] = useState(false);
  const [daysToFreeze, setDaysToFreeze] = useState(null);

  // STORE
  const getAbonementsClientList = useSelector(
    (state) => state.ClientsSlice.getAbonementsClientList
  );
  const getAbonementsClientListLoading = useSelector(
    (state) => state.ClientsSlice.getAbonementsClientListLoading
  );

  const searchItemsMap = (keys, values) => {
    const formattedItems = {};
    if (keys && values) {
      keys.forEach((key, index) => {
        if (values[index] && values[index][0]) {
          if (key === "id") {
            formattedItems["idFrom"] = values[index][0];
            formattedItems["idTo"] = values[index][1];
          } else if (key === "abonementFrom") {
            formattedItems["AbonementStartFrom"] = values[index][0];
            formattedItems["AbonementStartTo"] = values[index][1];
          } else if (key === "abonementTo") {
            formattedItems["AbonementEndFrom"] = values[index][0];
            formattedItems["AbonementEndTo"] = values[index][1];
          } else if (key === "frozenTo") {
            formattedItems["FrozenFrom"] = values[index][0];
            formattedItems["FrozenTo"] = values[index][1];
          } else if (key === "frostUse") {
            formattedItems["FrostDaysFrom"] = values[index][0];
            formattedItems["FrostDaysTo"] = values[index][1];
          } else if (key === "purchasePrice") {
            formattedItems["purchasePrice.From"] = values[index][0];
            formattedItems["purchasePrice.To"] = values[index][1];
          } else if (key === "addedFrostDays") {
            formattedItems["addedFrostDays.from"] = values[index][0];
            formattedItems["addedFrostDays.to"] = values[index][1];
          } else {
            formattedItems[key] = values[index][0];
          }
        }
      });
      return formattedItems;
    }
  };

  const onClickYesDeleteAbonement = () => {
    dispatch(
      deleteClientAbonement({
        clientId: clientInfo.id,
        abonementClubId: abonementInfo.abonementClubId,
        userAbonementId: abonementInfo.id
      })
    ).then(() => {
      dispatch(getAbonementsClient({ clientId: clientInfo.id }));
      setOpenDeliteAbonementModal(false);
    });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const payload = searchItemsMap(
      Object.keys(filters),
      Object.values(filters)
    );
    dispatch(
      getAbonementsClient({
        clientId: clientInfo.id,
        count: pagination.pageSize,
        offset: pagination.pageSize * (pagination.current - 1),
        orderBy: sorter?.column?.dataIndex,
        isDesc: sorter.order
          ? sorter.order === "ascend"
            ? true
            : false
          : undefined,
        isActive: isActive,
        isDeleted: isDeleted,
        ...payload,
      })
    );
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const onClickRowOne = (record) => {
    setIsAbonementInfo(record);
  };

  const disabledDate = (current, { from }) => {
    setDaysToFreeze(Math.abs(current.diff(dayjs(), "days")) + 1);
    return (
      Math.abs(current.diff(dayjs(), "days")) >=
      abonementInfo.frostDays -
        abonementInfo.frostUse +
        abonementInfo?.addedFrostDays
    );
  };

  const onClickCanFrostAboniment = (id, frozen) => {
    dispatch(
      frostClientAbonement({
        clientId: clientInfo.id,
        abonementClubId: id ? id : abonementInfo?.abonementClubId,
        frostDays: daysToFreeze && daysToFreeze,
      })
    ).then((value) => {
      setDate([dayjs()]);
      let result = value.payload.data.isSuccess;
      result && dispatch(getAbonementsClient({ clientId: clientInfo.id }));
      openNotification({
        type: "success",
        message: `Абонемент успешно ${frozen ? "разморожен" : "заморожен"}`,
      });
      setClicked(false);
    });
  };

  const onClickCancelClientSubscription = (id) => {
    dispatch(
      cancelClientSubscription({
        id: id,
      })
    )
      .then((value) => {
        let result = value.payload.data.isSuccess;
        result && dispatch(getAbonementsClient({ clientId: clientInfo.id }));
        openNotification({
          type: "success",
          message: `Подписка успешно отменена`,
        });
        setCancelClicked(false);
      })
      .catch((error) => {
        setCancelClicked(false);
      });
  };

  const content = (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <RangePicker
          value={date}
          disabledDate={disabledDate}
          onChange={setDate}
          format="DD.MM.YYYY"
          disabled={[true, false]}
        />
        <Space>
          <Button
            type="primary"
            size="small"
            style={{
              width: 90,
            }}
            onClick={() => {
              onClickCanFrostAboniment(
                abonementInfo.abonementClubId,
                abonementInfo.isFrozen,
                abonementInfo.daysToFreeze
              );
            }}
          >
            Заморозить
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              setClicked(false);
            }}
          >
            Закрыть
          </Button>
        </Space>
      </div>
    </>
  );

  const cancelContent = (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        Вы уверены, что хотите отказаться от подписки?{" "}
        <b>Это действие нельзя отменить</b> <br></br>
      </div>
      <Space>
        <Button
          type="primary"
          size="small"
          style={{
            width: 90,
          }}
          onClick={() => {
            onClickCancelClientSubscription(abonementInfo?.id);
          }}
        >
          Отказаться
        </Button>
        <Button
          type="link"
          size="small"
          onClick={() => {
            setCancelClicked(false);
          }}
        >
          Закрыть
        </Button>
      </Space>
    </>
  );

  const formatedClientsAbonementsRows =
    getAbonementsClientList?.data?.value?.rows.map((element) => {
      return {
        ...element,
        abonementFrom: element.abonementFrom
          ? dayjs(element?.abonementFrom).format("DD.MM.YYYY HH:mm:ss")
          : "",
        abonementTo: element.abonementTo
          ? dayjs(element?.abonementTo).format("DD.MM.YYYY HH:mm:ss")
          : "",
        isFrozen: !element.isFrozen ? (
          <Popover
            content={content}
            open={clicked && element?.id === abonementInfo?.id}
            title="Выберите дату до:"
          >
            <Switch
              onClick={() => {
                setIsAbonementInfo((prev) => (prev = element));
                setClicked(true);
              }}
              disabled={
                !element?.canFrost ||
                !mnemo?.children
                  ?.find((el) => el.name === "Таблица абонементов")
                  ?.children.find((ele) => ele.mnemo === "frost")
              }
              defaultChecked
              value={element?.isFrozen}
            />
          </Popover>
        ) : (
          <Switch
            onChange={() => {
              setIsAbonementInfo((prev) => (prev = element));
              onClickCanFrostAboniment(
                element.abonementClubId,
                element?.isFrozen
              );
            }}
            disabled={!element?.canFrost}
            defaultChecked
            value={element?.isFrozen}
          />
        ),
        frozenTo: element.frozenTo ? formateDate(element?.frozenTo) : "",
        hasSubscription:
          element?.id === abonementInfo?.id ? (
            <Popover
              content={cancelContent}
              open={cancelClicked}
              title="Внимание"
            >
              <Switch
                onClick={() => {
                  setIsAbonementInfo((prev) => element);
                  setCancelClicked(true);
                }}
                disabled={!element?.hasSubscription}
                defaultChecked
                value={element?.hasSubscription}
              />
            </Popover>
          ) : (
            <Switch
              onClick={() => {
                setIsAbonementInfo(element);
                setCancelClicked(true);
              }}
              disabled={!element?.hasSubscription}
              defaultChecked
              value={element?.hasSubscription}
            />
          ),
      };
    });

  return (
    <>
      <EditAbonement
        abonementModal={isOpenAddEditModal}
        setAbonementModal={setIsOpenAddEditModal}
        clientInfo={clientInfo}
        abonementInfo={abonementInfo}
      />
      <AbonementShowFr
        abonementModal={isOpenShowFrModal}
        setAbonementModal={setIsOpenShowFrModal}
        clientInfo={clientInfo}
        abonementInfo={abonementInfo}
        title={title}
        page={page}
        pageSize={pageSize}
        setPage={setPage}
        setPageSize={setPageSize}
        handleTableChange={handleTableChange}
        onClickRowOne={onClickRowOne}
      />
      <SureModal
        visible={openDeliteAbonementModal}
        setVisible={setOpenDeliteAbonementModal}
        onClickYes={onClickYesDeleteAbonement}
      />
      {window.innerWidth >= 768 && (
        <AdminTable
          scroll={{ x: 0, y: 200 }}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={getAbonementsClientListLoading}
          onClickRowOne={onClickRowOne}
          columns={getAbonementsClientList}
          rows={formatedClientsAbonementsRows}
          total={getAbonementsClientList?.data?.value?.totalCount}
          title={title}
          items={items}
        />
      )}
    </>
  );
};

export default ClientsAbonementsNew;
